import * as PropTypes from "prop-types";

import React from "react";
import TableRow from "./TableRow";
import { coalesce } from "../../../../utils/ObjectUtils";

/**
 * Table question component (table body) for survey-view.
 */
const TableQuestionBody = React.memo(({
  disabled,
  monitoringEditOnly,
  question,
  rows,
  questionAnswer,
  skipFirst,
  validation,
  editRow,
  deleteRow,
  addQuestionAnswer,
  setQuestionAnswer,
  removeQuestionAnswer,
  reorderQuestionRow,
  validateQuestionAnswer,
  textExpanded
}) => {
  // Build answersByRow on every render (simple & reliable)
    const answersByRow = new Map();
    for (const a of coalesce(questionAnswer.answers, [])) {
      if (!answersByRow.has(a.label)) answersByRow.set(a.label, []);
      answersByRow.get(a.label).push(a);
    }

  return (
    <tbody>
      {rows.map((row, index) => (
        <TableRow
          key={row.id}
          row={row}
          disabled={disabled}
          monitoringEditOnly={monitoringEditOnly}
          index={index}
          rowAnswers={answersByRow.get(row.name) || []}
          skipFirst={skipFirst}
          question={question}
          editRow={editRow}
          deleteRow={deleteRow}
          validation={validation}
          addQuestionAnswer={addQuestionAnswer}
          setQuestionAnswer={setQuestionAnswer}
          removeQuestionAnswer={removeQuestionAnswer}
          reorderQuestionRow={reorderQuestionRow}
          validateQuestionAnswer={validateQuestionAnswer}
          textExpanded={textExpanded}
        />
      ))}
    </tbody>
  );
});


TableQuestionBody.propTypes = {
  disabled: PropTypes.bool,
  monitoringEditOnly: PropTypes.bool,
  question: PropTypes.object.isRequired,
  rows: PropTypes.array.isRequired,
  questionAnswer: PropTypes.object.isRequired,
  skipFirst: PropTypes.bool,
  editRow: PropTypes.func.isRequired,
  deleteRow: PropTypes.func.isRequired,
  addQuestionAnswer: PropTypes.func.isRequired,
  setQuestionAnswer: PropTypes.func.isRequired,
  removeQuestionAnswer: PropTypes.func.isRequired,
  reorderQuestionRow: PropTypes.func.isRequired,
  validation: PropTypes.array,
  validateQuestionAnswer: PropTypes.func,
  textExpanded: PropTypes.bool
};

export default TableQuestionBody;
